"use client";

import { useEffect } from "react";
import { initializeAmplitude } from "./../lib/amplitude";

export default function AmplitudeInitializer() {
  useEffect(() => {
    initializeAmplitude();
  }, []);

  return null;
}
